export default __webpack_public_path__ + "static/roadmap-mobile-d665b0f63af0453509db6aa45e9ec5df.png";